import React from "react";
import { useForm } from "react-hook-form";
import { userService } from "@shared/ui";
import { useTranslation } from "react-i18next";

const FormChangeEmail: React.FC<{userId: number, setResult: (value: {email: string, res: boolean}) => void}> = ({userId, setResult}) => {
  const { t } = useTranslation();
  type FormValues = {
    email: string;
    password: string;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (form: FormValues) => {
    userService.updateUserEmail(form.email, form.password).then((data: boolean) => {
      if(data) {
          setResult({res: true, email: form.email});
      }

    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
      <label htmlFor="email">{t("formChangeEmail.labels.email")}</label>
      <input
        id="email"
        type="email"
        {...register("email", {
          required: t("formChangeEmail.errors.emailRequired"),
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: t("formChangeEmail.errors.emailInvalid"),
          },
        })}
        autoComplete="new-email"
      />
      {errors.email && <span className="error">{errors.email.message}</span>}

      <label htmlFor="password">{t("formChangeEmail.labels.password")}</label>
      <input
        id="password"
        {...register("password", {
          required: t("formChangeEmail.errors.passwordRequired"),
          minLength: {
            value: 5,
            message: "min length is 5",
          },
        })}
        type="password"
        autoComplete="new-password"
      />
      {errors.password && (
        <span className="error">{errors.password.message}</span>
      )}

      <input type="submit" value={t("formChangeEmail.submit")} />
    </form>
  )
};

export default FormChangeEmail;
